"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));
var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));
var _webSdk = _interopRequireDefault(require("@incognia/web-sdk"));
var _sha = _interopRequireDefault(require("crypto-js/sha256"));
var _encBase = _interopRequireDefault(require("crypto-js/enc-base64"));
var init = function () {
  var _ref = (0, _asyncToGenerator2.default)(_regenerator.default.mark(function _callee() {
    return _regenerator.default.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            return _context.abrupt("return", _webSdk.default.init({
              appId: process.env.INCOGNIA_APPLICATION_ID
            }));
          case 1:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));
  return function init() {
    return _ref.apply(this, arguments);
  };
}();
var generateRequestToken = function () {
  var _ref2 = (0, _asyncToGenerator2.default)(_regenerator.default.mark(function _callee2() {
    return _regenerator.default.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            return _context2.abrupt("return", _webSdk.default.generateRequestToken({
              askForGeolocation: true
            }));
          case 1:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2);
  }));
  return function generateRequestToken() {
    return _ref2.apply(this, arguments);
  };
}();
var setAccountId = function () {
  var _ref3 = (0, _asyncToGenerator2.default)(_regenerator.default.mark(function _callee3(accountId) {
    return _regenerator.default.wrap(function _callee3$(_context3) {
      while (1) {
        switch (_context3.prev = _context3.next) {
          case 0:
            return _context3.abrupt("return", _webSdk.default.setAccountId(accountId));
          case 1:
          case "end":
            return _context3.stop();
        }
      }
    }, _callee3);
  }));
  return function setAccountId(_x) {
    return _ref3.apply(this, arguments);
  };
}();
var sendAuthorizedLoginEvent = function () {
  var _ref4 = (0, _asyncToGenerator2.default)(_regenerator.default.mark(function _callee4(personUuid, phone) {
    return _regenerator.default.wrap(function _callee4$(_context4) {
      while (1) {
        switch (_context4.prev = _context4.next) {
          case 0:
            return _context4.abrupt("return", _webSdk.default.sendCustomEvent({
              tag: "login-attempt",
              accountId: personUuid,
              properties: {
                phone_hash: hash(phone),
                event_status: "AUTHORIZED"
              }
            }));
          case 1:
          case "end":
            return _context4.stop();
        }
      }
    }, _callee4);
  }));
  return function sendAuthorizedLoginEvent(_x2, _x3) {
    return _ref4.apply(this, arguments);
  };
}();
var sendDeniedLoginEvent = function () {
  var _ref5 = (0, _asyncToGenerator2.default)(_regenerator.default.mark(function _callee5(phone) {
    return _regenerator.default.wrap(function _callee5$(_context5) {
      while (1) {
        switch (_context5.prev = _context5.next) {
          case 0:
            return _context5.abrupt("return", _webSdk.default.sendCustomEvent({
              tag: "login-attempt",
              properties: {
                phone_hash: hash(phone),
                event_status: "DENIED"
              }
            }));
          case 1:
          case "end":
            return _context5.stop();
        }
      }
    }, _callee5);
  }));
  return function sendDeniedLoginEvent(_x4) {
    return _ref5.apply(this, arguments);
  };
}();
var hash = function hash(text) {
  return _encBase.default.stringify((0, _sha.default)(text));
};
var _default = {
  init: init,
  generateRequestToken: generateRequestToken,
  setAccountId: setAccountId,
  sendAuthorizedLoginEvent: sendAuthorizedLoginEvent,
  sendDeniedLoginEvent: sendDeniedLoginEvent
};
exports.default = _default;